window.field_data = {
  "data": [
    {
      "fieldname": "Photo Upload - Custom Heart",
      "directUpload": false,
      "atcTitle": "OPTIONAL: Upload your own photo",
      "uploadButtonText": "Upload Photo",
      "uploadButtonText2": "Change Photo",
      "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
      "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
      "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then 'Open in Chrome'",
      "buttonTextSize": "12",
      "buttonFontSize": 14,
      "fontStyle": "Theme Font",
      "introTitleColor": "#484848",
      "buttonCol": "#7E7E7E",
      "buttonBg": "#f1f1f1",
      "buttonTopBottomPadding": 10,
      "buttonLeftRightPadding": 10,
      "buttonBorderRadius": "0",
      "buttonWidth": "Full",
      "buttonDialogLang": "English",
      "dialogLanguage": "en",
      "opt1": true,
      "op2": false,
      "maximumFiles": 3,
      "minimumfiles": 0,
      "opt3": false,
      "fopt1": false,
      "fopt2": false,
      "fopt3": true,
      "pdf": false,
      "word": false,
      "customFile": false,
      "fileTypes": [],
      "buttonStatus": "Disable",
      "textFieldName": "Notes:",
      "fieldHelpText": "",
      "textFieldMaxLength": "No",
      "textFieldMaxChars": "30",
      "textFieldRequired": "No",
      "textFieldRequiredMessage": "Please enter a text!",
      "textFieldrequiredMessageButtonText": "OK",
      "fileSizeRestriction": false,
      "fileSizeRestrictionType": "minimumFileRestriction",
      "fileSizeMinimumRestriction": "2",
      "fileSizeMaximumRestriction": "4",
      "fileSizeMinMaxMinimum": "2",
      "fileSizeMinMaxMaximum": "4",
      "no": true,
      "yes": false,
      "fileRequiredMessage": "Please upload a file!",
      "fileRequiredMessageButtonText": "OK",
      "allowCropping": true,
      "croppingType": "aspect_ratio",
      "croppingAspectRatio": "5:5",
      "allowEditing": true,
      "editingType": "optional",
      "buttonStatus2": "Disable",
      "imageWidth": "1500",
      "imageHeight": "1500",
      "maxSizeRestriction": "Disable",
      "selectedUploadSources": "file url facebook instagram gdrive gphotos dropbox flickr onedrive",
      "productCondition": {
        "condition": "",
        "products": [
          "Picture Perfect Acrylic Frame - Heart Shape"
        ],
        "productIds": [
          "gid://shopify/Product/7403794137172"
        ],
        "collection": [],
        "collectionIds": [],
        "prodOpt": "",
        "prodTitleEqual": [],
        "prodTitleContains": [],
        "collOpt": "",
        "collectionTitleEqual": [],
        "collectionTitleContains": []
      },
      "allVariants": true,
      "anyConditionVariant": false,
      "allConditionVariant": false,
      "noneConditionVariant": false,
      "allVariantValues": [],
      "anyConditionCheck": false,
      "allConditionCheck": false,
      "showAllFields": false,
      "thisProduct": true,
      "thisCollection": false,
      "ucCustomTransalations": {
        "uploading": "Uploading... Please wait.",
        "loadingInfo": "Loading info...",
        "errors_default": "Error",
        "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
        "errors_baddata": "Incorrect value",
        "errors_size": "File too big",
        "errors_upload": "Can't upload",
        "errors_user": "Upload canceled",
        "errors_info": "Can't load info",
        "errors_image": "Only images allowed",
        "draghere": "Drop a file here",
        "one": "1 file",
        "file_other": "1 files",
        "buttons_cancel": "Cancel",
        "buttons_remove": "Remove",
        "buttons_choose_files_one": "Choose a file",
        "buttons_choose_files_other": "Choose files",
        "buttons_choose_images_one": "Choose an image",
        "buttons_choose_images_other": "Choose images",
        "dialog_close": "Close",
        "dialog_done": "Done",
        "dialog_showFiles": "Show files",
        "dialog_tabs_names_preview": "Preview",
        "dialog_tabs_names_file": "Local Files",
        "dialog_tabs_names_url": "Direct Link",
        "dialog_tabs_names_file_drag": "drag & drop<br>any files",
        "dialog_tabs_names_file_or": "or",
        "dialog_tabs_names_file_also": "or choose from",
        "dialog_tabs_names_file_button": "Choose a local file",
        "dialog_tabs_names_url_title": "Files from the Web",
        "dialog_tabs_names_url_line2": "Provide the link.",
        "dialog_tabs_names_url_input": "Paste your link here...",
        "dialog_tabs_names_url_button": "Upload",
        "dialog_tabs_names_camera_title": "File from web camera",
        "dialog_tabs_names_camera_capture": "Take a photo",
        "dialog_tabs_names_camera_mirror": "Mirror",
        "dialog_tabs_names_camera_startRecord": "Record a video",
        "dialog_tabs_names_camera_stopRecord": "Stop",
        "dialog_tabs_names_camera_retry": "Request permissions again",
        "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
        "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
        "notFound_title": "No camera detected",
        "notFound_text": "Looks like you have no camera connected to this device.",
        "dialog_tabs_names_preview_back": "Back",
        "dialog_tabs_names_preview_done": "Add",
        "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
        "dialog_tabs_names_preview_regular_title": "Add this file?",
        "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
        "dialog_tabs_names_preview_regular_line2": "Please confirm.",
        "dialog_tabs_names_preview_image_title": "Add this image?",
        "dialog_tabs_names_preview_crop_title": "Crop and add this image",
        "dialog_tabs_names_preview_crop_free": "free",
        "dialog_tabs_names_preview_video_title": "Add this video?",
        "dialog_tabs_names_preview_error_default_title": "Oops!",
        "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
        "dialog_tabs_names_preview_error_default_back": "Please try again",
        "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
        "dialog_tabs_names_preview_multiple_question": "Add files?",
        "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
        "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
        "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
        "dialog_tabs_names_preview_multiple_clear": "Remove all",
        "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
        "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
        "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
        "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
        "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
        "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
        "effects_captions_blur": "Blur",
        "effects_captions_crop": "Crop",
        "effects_captions_enhance": "Enhance",
        "effects_captions_flip": "Flip",
        "effects_captions_grayscale": "Grayscale",
        "effects_captions_invert": "Invert",
        "effects_captions_mirror": "Mirror",
        "effects_captions_rotate": "Rotate",
        "effects_captions_sharp": "Sharpen",
        "effects_apply_button": "Apply"
      },
      "fileRequiredButton": "",
      "previewStyle": "line_preview",
      "customStyling": {
        "container": "",
        "heading": "",
        "button": ""
      },
      "targetingType": "beginner",
      "thisProductVariants": false,
      "selectedProducts": [
        {
          "id": "gid://shopify/Product/7403794137172",
          "title": "Picture Perfect Acrylic Frame - Heart Shape",
          "imageSrc": "https://cdn.shopify.com/s/files/1/0267/5746/4148/files/123480_G_04_250da537-c0dc-4ae6-8f94-939cc39a8788.jpg?v=1719865580"
        }
      ],
      "fopt4": false,
      "fileExtensions": [],
      "pdf_settings": {
        "enabled": false,
        "minimum": 0,
        "maximum": 3
      },
      "translations": []
    },
    {
      "fieldname": "Photo Upload - Custom Flower",
      "directUpload": false,
      "atcTitle": "OPTIONAL: Upload your own photo",
      "uploadButtonText": "Upload Photo",
      "uploadButtonText2": "Change Photo",
      "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
      "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
      "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then 'Open in Chrome'",
      "buttonTextSize": "12",
      "buttonFontSize": 14,
      "fontStyle": "Theme Font",
      "introTitleColor": "#484848",
      "buttonCol": "#7E7E7E",
      "buttonBg": "#f1f1f1",
      "buttonTopBottomPadding": 10,
      "buttonLeftRightPadding": 10,
      "buttonBorderRadius": "0",
      "buttonWidth": "Full",
      "buttonDialogLang": "English",
      "dialogLanguage": "en",
      "opt1": true,
      "op2": false,
      "maximumFiles": 3,
      "minimumfiles": 0,
      "opt3": false,
      "fopt1": false,
      "fopt2": false,
      "fopt3": true,
      "pdf": false,
      "word": false,
      "customFile": false,
      "fileTypes": [],
      "buttonStatus": "Disable",
      "textFieldName": "Notes:",
      "fieldHelpText": "",
      "textFieldMaxLength": "No",
      "textFieldMaxChars": "30",
      "textFieldRequired": "No",
      "textFieldRequiredMessage": "Please enter a text!",
      "textFieldrequiredMessageButtonText": "OK",
      "fileSizeRestriction": false,
      "fileSizeRestrictionType": "minimumFileRestriction",
      "fileSizeMinimumRestriction": "2",
      "fileSizeMaximumRestriction": "4",
      "fileSizeMinMaxMinimum": "2",
      "fileSizeMinMaxMaximum": "4",
      "no": true,
      "yes": false,
      "fileRequiredMessage": "Please upload a file!",
      "fileRequiredMessageButtonText": "OK",
      "allowCropping": true,
      "croppingType": "aspect_ratio",
      "croppingAspectRatio": "4:4",
      "allowEditing": true,
      "editingType": "optional",
      "buttonStatus2": "Disable",
      "imageWidth": "1800",
      "imageHeight": "1200",
      "maxSizeRestriction": "Disable",
      "selectedUploadSources": "file url facebook instagram gdrive gphotos dropbox flickr onedrive",
      "productCondition": {
        "condition": "",
        "products": [
          "Picture Perfect Acrylic Frame - Flower Shape"
        ],
        "productIds": [
          "gid://shopify/Product/7404000477268"
        ],
        "collection": [],
        "collectionIds": [],
        "prodOpt": "",
        "prodTitleEqual": [],
        "prodTitleContains": [],
        "collOpt": "",
        "collectionTitleEqual": [],
        "collectionTitleContains": []
      },
      "allVariants": true,
      "anyConditionVariant": false,
      "allConditionVariant": false,
      "noneConditionVariant": false,
      "allVariantValues": [],
      "anyConditionCheck": false,
      "allConditionCheck": false,
      "showAllFields": false,
      "thisProduct": true,
      "thisCollection": false,
      "ucCustomTransalations": {
        "uploading": "Uploading... Please wait.",
        "loadingInfo": "Loading info...",
        "errors_default": "Error",
        "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
        "errors_baddata": "Incorrect value",
        "errors_size": "File too big",
        "errors_upload": "Can't upload",
        "errors_user": "Upload canceled",
        "errors_info": "Can't load info",
        "errors_image": "Only images allowed",
        "draghere": "Drop a file here",
        "one": "1 file",
        "file_other": "1 files",
        "buttons_cancel": "Cancel",
        "buttons_remove": "Remove",
        "buttons_choose_files_one": "Choose a file",
        "buttons_choose_files_other": "Choose files",
        "buttons_choose_images_one": "Choose an image",
        "buttons_choose_images_other": "Choose images",
        "dialog_close": "Close",
        "dialog_done": "Done",
        "dialog_showFiles": "Show files",
        "dialog_tabs_names_preview": "Preview",
        "dialog_tabs_names_file": "Local Files",
        "dialog_tabs_names_url": "Direct Link",
        "dialog_tabs_names_file_drag": "drag & drop<br>any files",
        "dialog_tabs_names_file_or": "or",
        "dialog_tabs_names_file_also": "or choose from",
        "dialog_tabs_names_file_button": "Choose a local file",
        "dialog_tabs_names_url_title": "Files from the Web",
        "dialog_tabs_names_url_line2": "Provide the link.",
        "dialog_tabs_names_url_input": "Paste your link here...",
        "dialog_tabs_names_url_button": "Upload",
        "dialog_tabs_names_camera_title": "File from web camera",
        "dialog_tabs_names_camera_capture": "Take a photo",
        "dialog_tabs_names_camera_mirror": "Mirror",
        "dialog_tabs_names_camera_startRecord": "Record a video",
        "dialog_tabs_names_camera_stopRecord": "Stop",
        "dialog_tabs_names_camera_retry": "Request permissions again",
        "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
        "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
        "notFound_title": "No camera detected",
        "notFound_text": "Looks like you have no camera connected to this device.",
        "dialog_tabs_names_preview_back": "Back",
        "dialog_tabs_names_preview_done": "Add",
        "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
        "dialog_tabs_names_preview_regular_title": "Add this file?",
        "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
        "dialog_tabs_names_preview_regular_line2": "Please confirm.",
        "dialog_tabs_names_preview_image_title": "Add this image?",
        "dialog_tabs_names_preview_crop_title": "Crop and add this image",
        "dialog_tabs_names_preview_crop_free": "free",
        "dialog_tabs_names_preview_video_title": "Add this video?",
        "dialog_tabs_names_preview_error_default_title": "Oops!",
        "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
        "dialog_tabs_names_preview_error_default_back": "Please try again",
        "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
        "dialog_tabs_names_preview_multiple_question": "Add files?",
        "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
        "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
        "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
        "dialog_tabs_names_preview_multiple_clear": "Remove all",
        "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
        "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
        "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
        "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
        "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
        "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
        "effects_captions_blur": "Blur",
        "effects_captions_crop": "Crop",
        "effects_captions_enhance": "Enhance",
        "effects_captions_flip": "Flip",
        "effects_captions_grayscale": "Grayscale",
        "effects_captions_invert": "Invert",
        "effects_captions_mirror": "Mirror",
        "effects_captions_rotate": "Rotate",
        "effects_captions_sharp": "Sharpen",
        "effects_apply_button": "Apply"
      },
      "fileRequiredButton": "",
      "previewStyle": "line_preview",
      "customStyling": {
        "container": "",
        "heading": "",
        "button": ""
      },
      "targetingType": "beginner",
      "thisProductVariants": false,
      "selectedProducts": [
        {
          "id": "gid://shopify/Product/7404000477268",
          "title": "Picture Perfect Acrylic Frame - Flower Shape",
          "imageSrc": "https://cdn.shopify.com/s/files/1/0267/5746/4148/files/123485_G_01_535d83ab-c4e9-4ebe-97f8-6a13a2e3258f.jpg?v=1723561797"
        }
      ],
      "fopt4": false,
      "fileExtensions": [],
      "pdf_settings": {
        "enabled": false,
        "minimum": 0,
        "maximum": 3
      },
      "translations": []
    },
    {
      "fieldname": "Photo Upload - Custom Retro Wavy",
      "directUpload": false,
      "atcTitle": "OPTIONAL: Upload your own photo",
      "uploadButtonText": "Upload Photo",
      "uploadButtonText2": "Change Photo",
      "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
      "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
      "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then 'Open in Chrome'",
      "buttonTextSize": "12",
      "buttonFontSize": 14,
      "fontStyle": "Theme Font",
      "introTitleColor": "#484848",
      "buttonCol": "#7E7E7E",
      "buttonBg": "#f1f1f1",
      "buttonTopBottomPadding": 10,
      "buttonLeftRightPadding": 10,
      "buttonBorderRadius": "0",
      "buttonWidth": "Full",
      "buttonDialogLang": "English",
      "dialogLanguage": "en",
      "opt1": true,
      "op2": false,
      "maximumFiles": 3,
      "minimumfiles": 0,
      "opt3": false,
      "fopt1": false,
      "fopt2": false,
      "fopt3": true,
      "pdf": false,
      "word": false,
      "customFile": false,
      "fileTypes": [],
      "buttonStatus": "Disable",
      "textFieldName": "Notes:",
      "fieldHelpText": "",
      "textFieldMaxLength": "No",
      "textFieldMaxChars": "30",
      "textFieldRequired": "No",
      "textFieldRequiredMessage": "Please enter a text!",
      "textFieldrequiredMessageButtonText": "OK",
      "fileSizeRestriction": false,
      "fileSizeRestrictionType": "minimumFileRestriction",
      "fileSizeMinimumRestriction": "2",
      "fileSizeMaximumRestriction": "4",
      "fileSizeMinMaxMinimum": "2",
      "fileSizeMinMaxMaximum": "4",
      "no": true,
      "yes": false,
      "fileRequiredMessage": "Please upload a file!",
      "fileRequiredMessageButtonText": "OK",
      "allowCropping": true,
      "croppingType": "aspect_ratio",
      "croppingAspectRatio": "5:7",
      "allowEditing": true,
      "editingType": "optional",
      "buttonStatus2": "Disable",
      "imageWidth": "1800",
      "imageHeight": "1200",
      "maxSizeRestriction": "Disable",
      "selectedUploadSources": "file url facebook instagram gdrive gphotos dropbox flickr onedrive",
      "productCondition": {
        "condition": "",
        "products": [
          "Picture Perfect Vertical Acrylic Frame  - Retro Wavy Shape"
        ],
        "productIds": [
          "gid://shopify/Product/7403794792532"
        ],
        "collection": [],
        "collectionIds": [],
        "prodOpt": "",
        "prodTitleEqual": [],
        "prodTitleContains": [],
        "collOpt": "",
        "collectionTitleEqual": [],
        "collectionTitleContains": []
      },
      "allVariants": true,
      "anyConditionVariant": false,
      "allConditionVariant": false,
      "noneConditionVariant": false,
      "allVariantValues": [],
      "anyConditionCheck": false,
      "allConditionCheck": false,
      "showAllFields": false,
      "thisProduct": true,
      "thisCollection": false,
      "ucCustomTransalations": {
        "uploading": "Uploading... Please wait.",
        "loadingInfo": "Loading info...",
        "errors_default": "Error",
        "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
        "errors_baddata": "Incorrect value",
        "errors_size": "File too big",
        "errors_upload": "Can't upload",
        "errors_user": "Upload canceled",
        "errors_info": "Can't load info",
        "errors_image": "Only images allowed",
        "draghere": "Drop a file here",
        "one": "1 file",
        "file_other": "1 files",
        "buttons_cancel": "Cancel",
        "buttons_remove": "Remove",
        "buttons_choose_files_one": "Choose a file",
        "buttons_choose_files_other": "Choose files",
        "buttons_choose_images_one": "Choose an image",
        "buttons_choose_images_other": "Choose images",
        "dialog_close": "Close",
        "dialog_done": "Done",
        "dialog_showFiles": "Show files",
        "dialog_tabs_names_preview": "Preview",
        "dialog_tabs_names_file": "Local Files",
        "dialog_tabs_names_url": "Direct Link",
        "dialog_tabs_names_file_drag": "drag & drop<br>any files",
        "dialog_tabs_names_file_or": "or",
        "dialog_tabs_names_file_also": "or choose from",
        "dialog_tabs_names_file_button": "Choose a local file",
        "dialog_tabs_names_url_title": "Files from the Web",
        "dialog_tabs_names_url_line2": "Provide the link.",
        "dialog_tabs_names_url_input": "Paste your link here...",
        "dialog_tabs_names_url_button": "Upload",
        "dialog_tabs_names_camera_title": "File from web camera",
        "dialog_tabs_names_camera_capture": "Take a photo",
        "dialog_tabs_names_camera_mirror": "Mirror",
        "dialog_tabs_names_camera_startRecord": "Record a video",
        "dialog_tabs_names_camera_stopRecord": "Stop",
        "dialog_tabs_names_camera_retry": "Request permissions again",
        "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
        "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
        "notFound_title": "No camera detected",
        "notFound_text": "Looks like you have no camera connected to this device.",
        "dialog_tabs_names_preview_back": "Back",
        "dialog_tabs_names_preview_done": "Add",
        "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
        "dialog_tabs_names_preview_regular_title": "Add this file?",
        "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
        "dialog_tabs_names_preview_regular_line2": "Please confirm.",
        "dialog_tabs_names_preview_image_title": "Add this image?",
        "dialog_tabs_names_preview_crop_title": "Crop and add this image",
        "dialog_tabs_names_preview_crop_free": "free",
        "dialog_tabs_names_preview_video_title": "Add this video?",
        "dialog_tabs_names_preview_error_default_title": "Oops!",
        "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
        "dialog_tabs_names_preview_error_default_back": "Please try again",
        "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
        "dialog_tabs_names_preview_multiple_question": "Add files?",
        "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
        "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
        "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
        "dialog_tabs_names_preview_multiple_clear": "Remove all",
        "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
        "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
        "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
        "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
        "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
        "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
        "effects_captions_blur": "Blur",
        "effects_captions_crop": "Crop",
        "effects_captions_enhance": "Enhance",
        "effects_captions_flip": "Flip",
        "effects_captions_grayscale": "Grayscale",
        "effects_captions_invert": "Invert",
        "effects_captions_mirror": "Mirror",
        "effects_captions_rotate": "Rotate",
        "effects_captions_sharp": "Sharpen",
        "effects_apply_button": "Apply"
      },
      "fileRequiredButton": "",
      "previewStyle": "line_preview",
      "customStyling": {
        "container": "",
        "heading": "",
        "button": ""
      },
      "targetingType": "beginner",
      "thisProductVariants": false,
      "selectedProducts": [
        {
          "id": "gid://shopify/Product/7403794792532",
          "title": "Picture Perfect Vertical Acrylic Frame  - Retro Wavy Shape",
          "imageSrc": "https://cdn.shopify.com/s/files/1/0267/5746/4148/files/123494_G_04.jpg?v=1719866467"
        }
      ],
      "fopt4": false,
      "fileExtensions": [],
      "pdf_settings": {
        "enabled": false,
        "minimum": 0,
        "maximum": 3
      },
      "translations": []
    },
    {
      "fieldname": "Photo Upload - Custom Wavy",
      "directUpload": false,
      "atcTitle": "OPTIONAL: Upload your own photo",
      "uploadButtonText": "Upload Photo",
      "uploadButtonText2": "Change Photo",
      "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
      "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
      "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then 'Open in Chrome'",
      "buttonTextSize": "12",
      "buttonFontSize": 14,
      "fontStyle": "Theme Font",
      "introTitleColor": "#484848",
      "buttonCol": "#7E7E7E",
      "buttonBg": "#f1f1f1",
      "buttonTopBottomPadding": 10,
      "buttonLeftRightPadding": 10,
      "buttonBorderRadius": "0",
      "buttonWidth": "Full",
      "buttonDialogLang": "English",
      "dialogLanguage": "en",
      "opt1": true,
      "op2": false,
      "maximumFiles": 3,
      "minimumfiles": 0,
      "opt3": false,
      "fopt1": false,
      "fopt2": false,
      "fopt3": true,
      "pdf": false,
      "word": false,
      "customFile": false,
      "fileTypes": [],
      "buttonStatus": "Disable",
      "textFieldName": "Notes:",
      "fieldHelpText": "",
      "textFieldMaxLength": "No",
      "textFieldMaxChars": "30",
      "textFieldRequired": "No",
      "textFieldRequiredMessage": "Please enter a text!",
      "textFieldrequiredMessageButtonText": "OK",
      "fileSizeRestriction": false,
      "fileSizeRestrictionType": "minimumFileRestriction",
      "fileSizeMinimumRestriction": "2",
      "fileSizeMaximumRestriction": "4",
      "fileSizeMinMaxMinimum": "2",
      "fileSizeMinMaxMaximum": "4",
      "no": true,
      "yes": false,
      "fileRequiredMessage": "Please upload a file!",
      "fileRequiredMessageButtonText": "OK",
      "allowCropping": true,
      "croppingType": "aspect_ratio",
      "croppingAspectRatio": "5:7",
      "allowEditing": true,
      "editingType": "optional",
      "buttonStatus2": "Disable",
      "imageWidth": "1500",
      "imageHeight": "2100",
      "maxSizeRestriction": "Disable",
      "selectedUploadSources": "file url facebook instagram gdrive gphotos dropbox flickr onedrive",
      "productCondition": {
        "condition": "",
        "products": [
          "Picture Perfect Vertical Acrylic Frame - Scalloped Shape"
        ],
        "productIds": [
          "gid://shopify/Product/7403793678420"
        ],
        "collection": [],
        "collectionIds": [],
        "prodOpt": "",
        "prodTitleEqual": [],
        "prodTitleContains": [],
        "collOpt": "",
        "collectionTitleEqual": [],
        "collectionTitleContains": []
      },
      "allVariants": true,
      "anyConditionVariant": false,
      "allConditionVariant": false,
      "noneConditionVariant": false,
      "allVariantValues": [],
      "anyConditionCheck": false,
      "allConditionCheck": false,
      "showAllFields": false,
      "thisProduct": true,
      "thisCollection": false,
      "ucCustomTransalations": {
        "uploading": "Uploading... Please wait.",
        "loadingInfo": "Loading info...",
        "errors_default": "Error",
        "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
        "errors_baddata": "Incorrect value",
        "errors_size": "File too big",
        "errors_upload": "Can't upload",
        "errors_user": "Upload canceled",
        "errors_info": "Can't load info",
        "errors_image": "Only images allowed",
        "draghere": "Drop a file here",
        "one": "1 file",
        "file_other": "1 files",
        "buttons_cancel": "Cancel",
        "buttons_remove": "Remove",
        "buttons_choose_files_one": "Choose a file",
        "buttons_choose_files_other": "Choose files",
        "buttons_choose_images_one": "Choose an image",
        "buttons_choose_images_other": "Choose images",
        "dialog_close": "Close",
        "dialog_done": "Done",
        "dialog_showFiles": "Show files",
        "dialog_tabs_names_preview": "Preview",
        "dialog_tabs_names_file": "Local Files",
        "dialog_tabs_names_url": "Direct Link",
        "dialog_tabs_names_file_drag": "drag & drop<br>any files",
        "dialog_tabs_names_file_or": "or",
        "dialog_tabs_names_file_also": "or choose from",
        "dialog_tabs_names_file_button": "Choose a local file",
        "dialog_tabs_names_url_title": "Files from the Web",
        "dialog_tabs_names_url_line2": "Provide the link.",
        "dialog_tabs_names_url_input": "Paste your link here...",
        "dialog_tabs_names_url_button": "Upload",
        "dialog_tabs_names_camera_title": "File from web camera",
        "dialog_tabs_names_camera_capture": "Take a photo",
        "dialog_tabs_names_camera_mirror": "Mirror",
        "dialog_tabs_names_camera_startRecord": "Record a video",
        "dialog_tabs_names_camera_stopRecord": "Stop",
        "dialog_tabs_names_camera_retry": "Request permissions again",
        "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
        "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
        "notFound_title": "No camera detected",
        "notFound_text": "Looks like you have no camera connected to this device.",
        "dialog_tabs_names_preview_back": "Back",
        "dialog_tabs_names_preview_done": "Add",
        "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
        "dialog_tabs_names_preview_regular_title": "Add this file?",
        "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
        "dialog_tabs_names_preview_regular_line2": "Please confirm.",
        "dialog_tabs_names_preview_image_title": "Add this image?",
        "dialog_tabs_names_preview_crop_title": "Crop and add this image",
        "dialog_tabs_names_preview_crop_free": "free",
        "dialog_tabs_names_preview_video_title": "Add this video?",
        "dialog_tabs_names_preview_error_default_title": "Oops!",
        "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
        "dialog_tabs_names_preview_error_default_back": "Please try again",
        "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
        "dialog_tabs_names_preview_multiple_question": "Add files?",
        "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
        "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
        "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
        "dialog_tabs_names_preview_multiple_clear": "Remove all",
        "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
        "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
        "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
        "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
        "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
        "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
        "effects_captions_blur": "Blur",
        "effects_captions_crop": "Crop",
        "effects_captions_enhance": "Enhance",
        "effects_captions_flip": "Flip",
        "effects_captions_grayscale": "Grayscale",
        "effects_captions_invert": "Invert",
        "effects_captions_mirror": "Mirror",
        "effects_captions_rotate": "Rotate",
        "effects_captions_sharp": "Sharpen",
        "effects_apply_button": "Apply"
      },
      "fileRequiredButton": "",
      "previewStyle": "line_preview",
      "customStyling": {
        "container": "",
        "heading": "",
        "button": ""
      },
      "targetingType": "beginner",
      "thisProductVariants": false,
      "selectedProducts": [
        {
          "id": "gid://shopify/Product/7403793678420",
          "title": "Picture Perfect Vertical Acrylic Frame - Scalloped Shape",
          "imageSrc": "https://cdn.shopify.com/s/files/1/0267/5746/4148/files/123465_G_04_66c54881-1fd9-4041-b847-f3e16d37d364.jpg?v=1719867116"
        }
      ],
      "fopt4": false,
      "fileExtensions": [],
      "pdf_settings": {
        "enabled": false,
        "minimum": 0,
        "maximum": 3
      },
      "translations": []
    },
    {
      "fieldname": "Photo Upload - Custom Rectangle",
      "directUpload": false,
      "atcTitle": "OPTIONAL: Upload your own photo",
      "uploadButtonText": "Upload Photo",
      "uploadButtonText2": "Change Photo",
      "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
      "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
      "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then 'Open in Chrome'",
      "buttonTextSize": "12",
      "buttonFontSize": 14,
      "fontStyle": "Theme Font",
      "introTitleColor": "#484848",
      "buttonCol": "#7E7E7E",
      "buttonBg": "#f1f1f1",
      "buttonTopBottomPadding": 10,
      "buttonLeftRightPadding": 10,
      "buttonBorderRadius": "0",
      "buttonWidth": "Full",
      "buttonDialogLang": "English",
      "dialogLanguage": "en",
      "opt1": true,
      "op2": false,
      "maximumFiles": 3,
      "minimumfiles": 0,
      "opt3": false,
      "fopt1": false,
      "fopt2": false,
      "fopt3": true,
      "pdf": false,
      "word": false,
      "customFile": false,
      "fileTypes": [],
      "buttonStatus": "Disable",
      "textFieldName": "Notes:",
      "fieldHelpText": "",
      "textFieldMaxLength": "No",
      "textFieldMaxChars": "30",
      "textFieldRequired": "No",
      "textFieldRequiredMessage": "Please enter a text!",
      "textFieldrequiredMessageButtonText": "OK",
      "fileSizeRestriction": false,
      "fileSizeRestrictionType": "minimumFileRestriction",
      "fileSizeMinimumRestriction": "2",
      "fileSizeMaximumRestriction": "4",
      "fileSizeMinMaxMinimum": "2",
      "fileSizeMinMaxMaximum": "4",
      "no": true,
      "yes": false,
      "fileRequiredMessage": "Please upload a file!",
      "fileRequiredMessageButtonText": "OK",
      "allowCropping": true,
      "croppingType": "aspect_ratio",
      "croppingAspectRatio": "5:7",
      "allowEditing": true,
      "editingType": "optional",
      "buttonStatus2": "Disable",
      "imageWidth": "1500",
      "imageHeight": "2100",
      "maxSizeRestriction": "Disable",
      "selectedUploadSources": "file url facebook instagram gdrive gphotos dropbox flickr onedrive",
      "productCondition": {
        "condition": "",
        "products": [
          "Picture Perfect Vertical Acrylic Frame - Rectangle Shape"
        ],
        "productIds": [
          "gid://shopify/Product/7403794202708"
        ],
        "collection": [],
        "collectionIds": [],
        "prodOpt": "",
        "prodTitleEqual": [],
        "prodTitleContains": [],
        "collOpt": "",
        "collectionTitleEqual": [],
        "collectionTitleContains": []
      },
      "allVariants": true,
      "anyConditionVariant": false,
      "allConditionVariant": false,
      "noneConditionVariant": false,
      "allVariantValues": [],
      "anyConditionCheck": false,
      "allConditionCheck": false,
      "showAllFields": false,
      "thisProduct": true,
      "thisCollection": false,
      "ucCustomTransalations": {
        "uploading": "Uploading... Please wait.",
        "loadingInfo": "Loading info...",
        "errors_default": "Error",
        "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
        "errors_baddata": "Incorrect value",
        "errors_size": "File too big",
        "errors_upload": "Can't upload",
        "errors_user": "Upload canceled",
        "errors_info": "Can't load info",
        "errors_image": "Only images allowed",
        "draghere": "Drop a file here",
        "one": "1 file",
        "file_other": "1 files",
        "buttons_cancel": "Cancel",
        "buttons_remove": "Remove",
        "buttons_choose_files_one": "Choose a file",
        "buttons_choose_files_other": "Choose files",
        "buttons_choose_images_one": "Choose an image",
        "buttons_choose_images_other": "Choose images",
        "dialog_close": "Close",
        "dialog_done": "Done",
        "dialog_showFiles": "Show files",
        "dialog_tabs_names_preview": "Preview",
        "dialog_tabs_names_file": "Local Files",
        "dialog_tabs_names_url": "Direct Link",
        "dialog_tabs_names_file_drag": "drag & drop<br>any files",
        "dialog_tabs_names_file_or": "or",
        "dialog_tabs_names_file_also": "or choose from",
        "dialog_tabs_names_file_button": "Choose a local file",
        "dialog_tabs_names_url_title": "Files from the Web",
        "dialog_tabs_names_url_line2": "Provide the link.",
        "dialog_tabs_names_url_input": "Paste your link here...",
        "dialog_tabs_names_url_button": "Upload",
        "dialog_tabs_names_camera_title": "File from web camera",
        "dialog_tabs_names_camera_capture": "Take a photo",
        "dialog_tabs_names_camera_mirror": "Mirror",
        "dialog_tabs_names_camera_startRecord": "Record a video",
        "dialog_tabs_names_camera_stopRecord": "Stop",
        "dialog_tabs_names_camera_retry": "Request permissions again",
        "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
        "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
        "notFound_title": "No camera detected",
        "notFound_text": "Looks like you have no camera connected to this device.",
        "dialog_tabs_names_preview_back": "Back",
        "dialog_tabs_names_preview_done": "Add",
        "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
        "dialog_tabs_names_preview_regular_title": "Add this file?",
        "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
        "dialog_tabs_names_preview_regular_line2": "Please confirm.",
        "dialog_tabs_names_preview_image_title": "Add this image?",
        "dialog_tabs_names_preview_crop_title": "Crop and add this image",
        "dialog_tabs_names_preview_crop_free": "free",
        "dialog_tabs_names_preview_video_title": "Add this video?",
        "dialog_tabs_names_preview_error_default_title": "Oops!",
        "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
        "dialog_tabs_names_preview_error_default_back": "Please try again",
        "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
        "dialog_tabs_names_preview_multiple_question": "Add files?",
        "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
        "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
        "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
        "dialog_tabs_names_preview_multiple_clear": "Remove all",
        "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
        "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
        "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
        "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
        "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
        "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
        "effects_captions_blur": "Blur",
        "effects_captions_crop": "Crop",
        "effects_captions_enhance": "Enhance",
        "effects_captions_flip": "Flip",
        "effects_captions_grayscale": "Grayscale",
        "effects_captions_invert": "Invert",
        "effects_captions_mirror": "Mirror",
        "effects_captions_rotate": "Rotate",
        "effects_captions_sharp": "Sharpen",
        "effects_apply_button": "Apply"
      },
      "fileRequiredButton": "",
      "previewStyle": "line_preview",
      "customStyling": {
        "container": "",
        "heading": "",
        "button": ""
      },
      "targetingType": "beginner",
      "thisProductVariants": false,
      "selectedProducts": [
        {
          "id": "gid://shopify/Product/7403794202708",
          "title": "Picture Perfect Vertical Acrylic Frame - Rectangle Shape",
          "imageSrc": "https://cdn.shopify.com/s/files/1/0267/5746/4148/files/123457_G_04.jpg?v=1738341934"
        }
      ],
      "fopt4": false,
      "fileExtensions": [],
      "pdf_settings": {
        "enabled": false,
        "minimum": 0,
        "maximum": 3
      },
      "translations": []
    },
    {
      "fieldname": "Photo Upload - Horizontal Rectangle Shape",
      "directUpload": false,
      "atcTitle": "OPTIONAL: Upload your own photo",
      "uploadButtonText": "Upload Photo",
      "uploadButtonText2": "Change Photo",
      "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
      "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
      "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then 'Open in Chrome'",
      "buttonTextSize": "12",
      "buttonFontSize": 14,
      "fontStyle": "Theme Font",
      "introTitleColor": "#484848",
      "buttonCol": "#7E7E7E",
      "buttonBg": "#f1f1f1",
      "buttonTopBottomPadding": 10,
      "buttonLeftRightPadding": 10,
      "buttonBorderRadius": "0",
      "buttonWidth": "Full",
      "buttonDialogLang": "English",
      "dialogLanguage": "en",
      "opt1": true,
      "op2": false,
      "maximumFiles": 3,
      "minimumfiles": 0,
      "opt3": false,
      "fopt1": false,
      "fopt2": false,
      "fopt3": true,
      "pdf": false,
      "word": false,
      "customFile": false,
      "fileTypes": [],
      "buttonStatus": "Disable",
      "textFieldName": "Notes:",
      "fieldHelpText": "",
      "textFieldMaxLength": "No",
      "textFieldMaxChars": "30",
      "textFieldRequired": "No",
      "textFieldRequiredMessage": "Please enter a text!",
      "textFieldrequiredMessageButtonText": "OK",
      "fileSizeRestriction": false,
      "fileSizeRestrictionType": "minimumFileRestriction",
      "fileSizeMinimumRestriction": "2",
      "fileSizeMaximumRestriction": "4",
      "fileSizeMinMaxMinimum": "2",
      "fileSizeMinMaxMaximum": "4",
      "no": true,
      "yes": false,
      "fileRequiredMessage": "Please upload a file!",
      "fileRequiredMessageButtonText": "OK",
      "allowCropping": true,
      "croppingType": "aspect_ratio",
      "croppingAspectRatio": "7:5",
      "allowEditing": true,
      "editingType": "optional",
      "buttonStatus2": "Disable",
      "imageWidth": "1800",
      "imageHeight": "1200",
      "maxSizeRestriction": "Disable",
      "selectedUploadSources": "file url facebook instagram gdrive gphotos dropbox flickr onedrive",
      "productCondition": {
        "condition": "",
        "products": [
          "Picture Perfect Horizontal Acrylic Frame - Rectangle Shape"
        ],
        "productIds": [
          "gid://shopify/Product/7482865123412"
        ],
        "collection": [],
        "collectionIds": [],
        "prodOpt": "",
        "prodTitleEqual": [],
        "prodTitleContains": [],
        "collOpt": "",
        "collectionTitleEqual": [],
        "collectionTitleContains": []
      },
      "allVariants": true,
      "anyConditionVariant": false,
      "allConditionVariant": false,
      "noneConditionVariant": false,
      "allVariantValues": [],
      "anyConditionCheck": false,
      "allConditionCheck": false,
      "showAllFields": false,
      "thisProduct": true,
      "thisCollection": false,
      "ucCustomTransalations": {
        "uploading": "Uploading... Please wait.",
        "loadingInfo": "Loading info...",
        "errors_default": "Error",
        "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
        "errors_baddata": "Incorrect value",
        "errors_size": "File too big",
        "errors_upload": "Can't upload",
        "errors_user": "Upload canceled",
        "errors_info": "Can't load info",
        "errors_image": "Only images allowed",
        "draghere": "Drop a file here",
        "one": "1 file",
        "file_other": "1 files",
        "buttons_cancel": "Cancel",
        "buttons_remove": "Remove",
        "buttons_choose_files_one": "Choose a file",
        "buttons_choose_files_other": "Choose files",
        "buttons_choose_images_one": "Choose an image",
        "buttons_choose_images_other": "Choose images",
        "dialog_close": "Close",
        "dialog_done": "Done",
        "dialog_showFiles": "Show files",
        "dialog_tabs_names_preview": "Preview",
        "dialog_tabs_names_file": "Local Files",
        "dialog_tabs_names_url": "Direct Link",
        "dialog_tabs_names_file_drag": "drag & drop<br>any files",
        "dialog_tabs_names_file_or": "or",
        "dialog_tabs_names_file_also": "or choose from",
        "dialog_tabs_names_file_button": "Choose a local file",
        "dialog_tabs_names_url_title": "Files from the Web",
        "dialog_tabs_names_url_line2": "Provide the link.",
        "dialog_tabs_names_url_input": "Paste your link here...",
        "dialog_tabs_names_url_button": "Upload",
        "dialog_tabs_names_camera_title": "File from web camera",
        "dialog_tabs_names_camera_capture": "Take a photo",
        "dialog_tabs_names_camera_mirror": "Mirror",
        "dialog_tabs_names_camera_startRecord": "Record a video",
        "dialog_tabs_names_camera_stopRecord": "Stop",
        "dialog_tabs_names_camera_retry": "Request permissions again",
        "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
        "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
        "notFound_title": "No camera detected",
        "notFound_text": "Looks like you have no camera connected to this device.",
        "dialog_tabs_names_preview_back": "Back",
        "dialog_tabs_names_preview_done": "Add",
        "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
        "dialog_tabs_names_preview_regular_title": "Add this file?",
        "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
        "dialog_tabs_names_preview_regular_line2": "Please confirm.",
        "dialog_tabs_names_preview_image_title": "Add this image?",
        "dialog_tabs_names_preview_crop_title": "Crop and add this image",
        "dialog_tabs_names_preview_crop_free": "free",
        "dialog_tabs_names_preview_video_title": "Add this video?",
        "dialog_tabs_names_preview_error_default_title": "Oops!",
        "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
        "dialog_tabs_names_preview_error_default_back": "Please try again",
        "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
        "dialog_tabs_names_preview_multiple_question": "Add files?",
        "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
        "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
        "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
        "dialog_tabs_names_preview_multiple_clear": "Remove all",
        "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
        "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
        "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
        "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
        "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
        "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
        "effects_captions_blur": "Blur",
        "effects_captions_crop": "Crop",
        "effects_captions_enhance": "Enhance",
        "effects_captions_flip": "Flip",
        "effects_captions_grayscale": "Grayscale",
        "effects_captions_invert": "Invert",
        "effects_captions_mirror": "Mirror",
        "effects_captions_rotate": "Rotate",
        "effects_captions_sharp": "Sharpen",
        "effects_apply_button": "Apply"
      },
      "fileRequiredButton": "",
      "previewStyle": "line_preview",
      "customStyling": {
        "container": "",
        "heading": "",
        "button": ""
      },
      "targetingType": "beginner",
      "thisProductVariants": false,
      "selectedProducts": [
        {
          "id": "gid://shopify/Product/7482865123412",
          "title": "Picture Perfect Horizontal Acrylic Frame - Rectangle Shape"
        }
      ],
      "fopt4": false,
      "fileExtensions": [],
      "pdf_settings": {
        "enabled": false,
        "minimum": 0,
        "maximum": 3
      },
      "translations": []
    },
    {
      "fieldname": "Photo Upload - Horizontal Retro Wavy",
      "directUpload": false,
      "atcTitle": "OPTIONAL: Upload your own photo",
      "uploadButtonText": "Upload Photo",
      "uploadButtonText2": "Change Photo",
      "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
      "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
      "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then 'Open in Chrome'",
      "buttonTextSize": "12",
      "buttonFontSize": 14,
      "fontStyle": "Theme Font",
      "introTitleColor": "#484848",
      "buttonCol": "#7E7E7E",
      "buttonBg": "#f1f1f1",
      "buttonTopBottomPadding": "10",
      "buttonLeftRightPadding": 10,
      "buttonBorderRadius": "0",
      "buttonWidth": "Full",
      "buttonDialogLang": "English",
      "dialogLanguage": "en",
      "opt1": true,
      "op2": false,
      "maximumFiles": 3,
      "minimumfiles": 0,
      "opt3": false,
      "fopt1": false,
      "fopt2": false,
      "fopt3": true,
      "pdf": false,
      "word": false,
      "customFile": false,
      "fileTypes": [],
      "buttonStatus": "Disable",
      "textFieldName": "Notes:",
      "fieldHelpText": "",
      "textFieldMaxLength": "No",
      "textFieldMaxChars": "30",
      "textFieldRequired": "No",
      "textFieldRequiredMessage": "Please enter a text!",
      "textFieldrequiredMessageButtonText": "OK",
      "fileSizeRestriction": false,
      "fileSizeRestrictionType": "minimumFileRestriction",
      "fileSizeMinimumRestriction": "2",
      "fileSizeMaximumRestriction": "4",
      "fileSizeMinMaxMinimum": "2",
      "fileSizeMinMaxMaximum": "4",
      "no": true,
      "yes": false,
      "fileRequiredMessage": "Please upload a file!",
      "fileRequiredMessageButtonText": "OK",
      "allowCropping": true,
      "croppingType": "aspect_ratio",
      "croppingAspectRatio": "7:5",
      "allowEditing": true,
      "editingType": "optional",
      "buttonStatus2": "Disable",
      "imageWidth": "1800",
      "imageHeight": "1200",
      "maxSizeRestriction": "Disable",
      "selectedUploadSources": "file url facebook instagram gdrive gphotos dropbox flickr onedrive",
      "productCondition": {
        "condition": "",
        "products": [
          "Custom Retro Wavy Picture Frame - Horizontal"
        ],
        "productIds": [
          "gid://shopify/Product/7482865156180"
        ],
        "collection": [],
        "collectionIds": [],
        "prodOpt": "",
        "prodTitleEqual": [],
        "prodTitleContains": [],
        "collOpt": "",
        "collectionTitleEqual": [],
        "collectionTitleContains": []
      },
      "allVariants": true,
      "anyConditionVariant": false,
      "allConditionVariant": false,
      "noneConditionVariant": false,
      "allVariantValues": [],
      "anyConditionCheck": false,
      "allConditionCheck": false,
      "showAllFields": false,
      "thisProduct": true,
      "thisCollection": false,
      "ucCustomTransalations": {
        "uploading": "Uploading... Please wait.",
        "loadingInfo": "Loading info...",
        "errors_default": "Error",
        "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
        "errors_baddata": "Incorrect value",
        "errors_size": "File too big",
        "errors_upload": "Can't upload",
        "errors_user": "Upload canceled",
        "errors_info": "Can't load info",
        "errors_image": "Only images allowed",
        "draghere": "Drop a file here",
        "one": "1 file",
        "file_other": "1 files",
        "buttons_cancel": "Cancel",
        "buttons_remove": "Remove",
        "buttons_choose_files_one": "Choose a file",
        "buttons_choose_files_other": "Choose files",
        "buttons_choose_images_one": "Choose an image",
        "buttons_choose_images_other": "Choose images",
        "dialog_close": "Close",
        "dialog_done": "Done",
        "dialog_showFiles": "Show files",
        "dialog_tabs_names_preview": "Preview",
        "dialog_tabs_names_file": "Local Files",
        "dialog_tabs_names_url": "Direct Link",
        "dialog_tabs_names_file_drag": "drag & drop<br>any files",
        "dialog_tabs_names_file_or": "or",
        "dialog_tabs_names_file_also": "or choose from",
        "dialog_tabs_names_file_button": "Choose a local file",
        "dialog_tabs_names_url_title": "Files from the Web",
        "dialog_tabs_names_url_line2": "Provide the link.",
        "dialog_tabs_names_url_input": "Paste your link here...",
        "dialog_tabs_names_url_button": "Upload",
        "dialog_tabs_names_camera_title": "File from web camera",
        "dialog_tabs_names_camera_capture": "Take a photo",
        "dialog_tabs_names_camera_mirror": "Mirror",
        "dialog_tabs_names_camera_startRecord": "Record a video",
        "dialog_tabs_names_camera_stopRecord": "Stop",
        "dialog_tabs_names_camera_retry": "Request permissions again",
        "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
        "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
        "notFound_title": "No camera detected",
        "notFound_text": "Looks like you have no camera connected to this device.",
        "dialog_tabs_names_preview_back": "Back",
        "dialog_tabs_names_preview_done": "Add",
        "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
        "dialog_tabs_names_preview_regular_title": "Add this file?",
        "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
        "dialog_tabs_names_preview_regular_line2": "Please confirm.",
        "dialog_tabs_names_preview_image_title": "Add this image?",
        "dialog_tabs_names_preview_crop_title": "Crop and add this image",
        "dialog_tabs_names_preview_crop_free": "free",
        "dialog_tabs_names_preview_video_title": "Add this video?",
        "dialog_tabs_names_preview_error_default_title": "Oops!",
        "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
        "dialog_tabs_names_preview_error_default_back": "Please try again",
        "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
        "dialog_tabs_names_preview_multiple_question": "Add files?",
        "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
        "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
        "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
        "dialog_tabs_names_preview_multiple_clear": "Remove all",
        "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
        "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
        "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
        "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
        "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
        "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
        "effects_captions_blur": "Blur",
        "effects_captions_crop": "Crop",
        "effects_captions_enhance": "Enhance",
        "effects_captions_flip": "Flip",
        "effects_captions_grayscale": "Grayscale",
        "effects_captions_invert": "Invert",
        "effects_captions_mirror": "Mirror",
        "effects_captions_rotate": "Rotate",
        "effects_captions_sharp": "Sharpen",
        "effects_apply_button": "Apply"
      },
      "fileRequiredButton": "",
      "previewStyle": "line_preview",
      "customStyling": {
        "container": "",
        "heading": "",
        "button": ""
      },
      "targetingType": "beginner",
      "thisProductVariants": false,
      "selectedProducts": [
        {
          "id": "gid://shopify/Product/7482865156180",
          "title": "Custom Retro Wavy Picture Frame - Horizontal"
        }
      ],
      "fopt4": false,
      "fileExtensions": [],
      "pdf_settings": {
        "enabled": false,
        "minimum": 0,
        "maximum": 3
      },
      "translations": []
    },
    {
      "fieldname": "Photo Upload - Horizontal Scalloped",
      "directUpload": false,
      "atcTitle": "OPTIONAL: Upload your own photo",
      "uploadButtonText": "Upload Photo",
      "uploadButtonText2": "Change Photo",
      "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
      "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
      "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then 'Open in Chrome'",
      "buttonTextSize": "12",
      "buttonFontSize": 14,
      "fontStyle": "Theme Font",
      "introTitleColor": "#484848",
      "buttonCol": "#7E7E7E",
      "buttonBg": "#f1f1f1",
      "buttonTopBottomPadding": 10,
      "buttonLeftRightPadding": 10,
      "buttonBorderRadius": "0",
      "buttonWidth": "Full",
      "buttonDialogLang": "English",
      "dialogLanguage": "en",
      "opt1": true,
      "op2": false,
      "maximumFiles": 3,
      "minimumfiles": 0,
      "opt3": false,
      "fopt1": false,
      "fopt2": false,
      "fopt3": true,
      "pdf": false,
      "word": false,
      "customFile": false,
      "fileTypes": [],
      "buttonStatus": "Disable",
      "textFieldName": "Notes:",
      "fieldHelpText": "",
      "textFieldMaxLength": "No",
      "textFieldMaxChars": "30",
      "textFieldRequired": "No",
      "textFieldRequiredMessage": "Please enter a text!",
      "textFieldrequiredMessageButtonText": "OK",
      "fileSizeRestriction": false,
      "fileSizeRestrictionType": "minimumFileRestriction",
      "fileSizeMinimumRestriction": "2",
      "fileSizeMaximumRestriction": "4",
      "fileSizeMinMaxMinimum": "2",
      "fileSizeMinMaxMaximum": "4",
      "no": true,
      "yes": false,
      "fileRequiredMessage": "Please upload a file!",
      "fileRequiredMessageButtonText": "OK",
      "allowCropping": true,
      "croppingType": "aspect_ratio",
      "croppingAspectRatio": "7:5",
      "allowEditing": true,
      "editingType": "optional",
      "buttonStatus2": "Disable",
      "imageWidth": "1800",
      "imageHeight": "1200",
      "maxSizeRestriction": "Disable",
      "selectedUploadSources": "file url facebook instagram gdrive gphotos dropbox flickr onedrive",
      "productCondition": {
        "condition": "",
        "products": [
          "Picture Perfect Horizontal Acrylic Frame  - Scalloped Shape"
        ],
        "productIds": [
          "gid://shopify/Product/7482865188948"
        ],
        "collection": [],
        "collectionIds": [],
        "prodOpt": "",
        "prodTitleEqual": [],
        "prodTitleContains": [],
        "collOpt": "",
        "collectionTitleEqual": [],
        "collectionTitleContains": []
      },
      "allVariants": true,
      "anyConditionVariant": false,
      "allConditionVariant": false,
      "noneConditionVariant": false,
      "allVariantValues": [],
      "anyConditionCheck": false,
      "allConditionCheck": false,
      "showAllFields": false,
      "thisProduct": true,
      "thisCollection": false,
      "ucCustomTransalations": {
        "uploading": "Uploading... Please wait.",
        "loadingInfo": "Loading info...",
        "errors_default": "Error",
        "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
        "errors_baddata": "Incorrect value",
        "errors_size": "File too big",
        "errors_upload": "Can't upload",
        "errors_user": "Upload canceled",
        "errors_info": "Can't load info",
        "errors_image": "Only images allowed",
        "draghere": "Drop a file here",
        "one": "1 file",
        "file_other": "1 files",
        "buttons_cancel": "Cancel",
        "buttons_remove": "Remove",
        "buttons_choose_files_one": "Choose a file",
        "buttons_choose_files_other": "Choose files",
        "buttons_choose_images_one": "Choose an image",
        "buttons_choose_images_other": "Choose images",
        "dialog_close": "Close",
        "dialog_done": "Done",
        "dialog_showFiles": "Show files",
        "dialog_tabs_names_preview": "Preview",
        "dialog_tabs_names_file": "Local Files",
        "dialog_tabs_names_url": "Direct Link",
        "dialog_tabs_names_file_drag": "drag & drop<br>any files",
        "dialog_tabs_names_file_or": "or",
        "dialog_tabs_names_file_also": "or choose from",
        "dialog_tabs_names_file_button": "Choose a local file",
        "dialog_tabs_names_url_title": "Files from the Web",
        "dialog_tabs_names_url_line2": "Provide the link.",
        "dialog_tabs_names_url_input": "Paste your link here...",
        "dialog_tabs_names_url_button": "Upload",
        "dialog_tabs_names_camera_title": "File from web camera",
        "dialog_tabs_names_camera_capture": "Take a photo",
        "dialog_tabs_names_camera_mirror": "Mirror",
        "dialog_tabs_names_camera_startRecord": "Record a video",
        "dialog_tabs_names_camera_stopRecord": "Stop",
        "dialog_tabs_names_camera_retry": "Request permissions again",
        "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
        "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
        "notFound_title": "No camera detected",
        "notFound_text": "Looks like you have no camera connected to this device.",
        "dialog_tabs_names_preview_back": "Back",
        "dialog_tabs_names_preview_done": "Add",
        "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
        "dialog_tabs_names_preview_regular_title": "Add this file?",
        "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
        "dialog_tabs_names_preview_regular_line2": "Please confirm.",
        "dialog_tabs_names_preview_image_title": "Add this image?",
        "dialog_tabs_names_preview_crop_title": "Crop and add this image",
        "dialog_tabs_names_preview_crop_free": "free",
        "dialog_tabs_names_preview_video_title": "Add this video?",
        "dialog_tabs_names_preview_error_default_title": "Oops!",
        "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
        "dialog_tabs_names_preview_error_default_back": "Please try again",
        "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
        "dialog_tabs_names_preview_multiple_question": "Add files?",
        "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
        "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
        "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
        "dialog_tabs_names_preview_multiple_clear": "Remove all",
        "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
        "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
        "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
        "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
        "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
        "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
        "effects_captions_blur": "Blur",
        "effects_captions_crop": "Crop",
        "effects_captions_enhance": "Enhance",
        "effects_captions_flip": "Flip",
        "effects_captions_grayscale": "Grayscale",
        "effects_captions_invert": "Invert",
        "effects_captions_mirror": "Mirror",
        "effects_captions_rotate": "Rotate",
        "effects_captions_sharp": "Sharpen",
        "effects_apply_button": "Apply"
      },
      "fileRequiredButton": "",
      "previewStyle": "line_preview",
      "customStyling": {
        "container": "",
        "heading": "",
        "button": ""
      },
      "targetingType": "beginner",
      "thisProductVariants": false,
      "selectedProducts": [
        {
          "id": "gid://shopify/Product/7482865188948",
          "title": "Picture Perfect Horizontal Acrylic Frame  - Scalloped Shape",
          "imageSrc": "https://cdn.shopify.com/s/files/1/0267/5746/4148/files/123470_G_03.jpg?v=1723144830"
        }
      ],
      "fopt4": false,
      "fileExtensions": [],
      "pdf_settings": {
        "enabled": false,
        "minimum": 0,
        "maximum": 3
      },
      "translations": []
    },
    {
      "fieldname": "Photo Upload - minibar Custom Locket Round",
      "directUpload": false,
      "atcTitle": "OPTIONAL: Upload your own photo",
      "uploadButtonText": "Upload Photo",
      "uploadButtonText2": "Change Photo",
      "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
      "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
      "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then 'Open in Chrome'",
      "buttonTextSize": "12",
      "buttonFontSize": 14,
      "fontStyle": "Theme Font",
      "introTitleColor": "#484848",
      "buttonCol": "#7E7E7E",
      "buttonBg": "#f1f1f1",
      "buttonTopBottomPadding": 10,
      "buttonLeftRightPadding": 10,
      "buttonBorderRadius": "0",
      "buttonWidth": "Full",
      "buttonDialogLang": "English",
      "dialogLanguage": "en",
      "opt1": true,
      "op2": false,
      "maximumFiles": 3,
      "minimumfiles": 0,
      "opt3": false,
      "fopt1": false,
      "fopt2": false,
      "fopt3": true,
      "pdf": false,
      "word": false,
      "customFile": false,
      "fileTypes": [],
      "buttonStatus": "Disable",
      "textFieldName": "Notes:",
      "fieldHelpText": "",
      "textFieldMaxLength": "No",
      "textFieldMaxChars": "30",
      "textFieldRequired": "No",
      "textFieldRequiredMessage": "Please enter a text!",
      "textFieldrequiredMessageButtonText": "OK",
      "fileSizeRestriction": true,
      "fileSizeRestrictionType": "maximumFileSize",
      "fileSizeMinimumRestriction": "",
      "fileSizeMaximumRestriction": "1",
      "fileSizeMinMaxMinimum": "",
      "fileSizeMinMaxMaximum": "1",
      "no": true,
      "yes": false,
      "fileRequiredMessage": "Please upload a file!",
      "fileRequiredMessageButtonText": "OK",
      "allowCropping": true,
      "croppingType": "circle",
      "croppingAspectRatio": "5:5",
      "allowEditing": true,
      "editingType": "optional",
      "buttonStatus2": "Enable",
      "imageWidth": "818",
      "imageHeight": "1258",
      "maxSizeRestriction": "Disable",
      "selectedUploadSources": "file url facebook instagram gdrive gphotos dropbox flickr onedrive",
      "productCondition": {
        "condition": "",
        "products": [
          "Lil' Peacemaker Kids' Locket Necklace - Peace",
          "Lil' Smiley Kids' Locket Necklace - Smiley Face",
          "Lil' Sweetheart Kids' Locket Necklace - Heart"
        ],
        "productIds": [
          "gid://shopify/Product/7607998840916",
          "gid://shopify/Product/7607998906452",
          "gid://shopify/Product/7607998873684"
        ],
        "collection": [],
        "collectionIds": [],
        "prodOpt": "",
        "prodTitleEqual": [],
        "prodTitleContains": [],
        "collOpt": "",
        "collectionTitleEqual": [],
        "collectionTitleContains": []
      },
      "allVariants": true,
      "anyConditionVariant": false,
      "allConditionVariant": false,
      "noneConditionVariant": false,
      "allVariantValues": [],
      "anyConditionCheck": false,
      "allConditionCheck": false,
      "showAllFields": false,
      "thisProduct": true,
      "thisCollection": false,
      "ucCustomTransalations": {
        "uploading": "Uploading... Please wait.",
        "loadingInfo": "Loading info...",
        "errors_default": "Error",
        "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
        "errors_baddata": "Incorrect value",
        "errors_size": "File too big",
        "errors_upload": "Can't upload",
        "errors_user": "Upload canceled",
        "errors_info": "Can't load info",
        "errors_image": "Only images allowed",
        "draghere": "Drop a file here",
        "one": "1 file",
        "file_other": "1 files",
        "buttons_cancel": "Cancel",
        "buttons_remove": "Remove",
        "buttons_choose_files_one": "Choose a file",
        "buttons_choose_files_other": "Choose files",
        "buttons_choose_images_one": "Choose an image",
        "buttons_choose_images_other": "Choose images",
        "dialog_close": "Close",
        "dialog_done": "Done",
        "dialog_showFiles": "Show files",
        "dialog_tabs_names_preview": "Preview",
        "dialog_tabs_names_file": "Local Files",
        "dialog_tabs_names_url": "Direct Link",
        "dialog_tabs_names_file_drag": "drag & drop<br>any files",
        "dialog_tabs_names_file_or": "or",
        "dialog_tabs_names_file_also": "or choose from",
        "dialog_tabs_names_file_button": "Choose a local file",
        "dialog_tabs_names_url_title": "Files from the Web",
        "dialog_tabs_names_url_line2": "Provide the link.",
        "dialog_tabs_names_url_input": "Paste your link here...",
        "dialog_tabs_names_url_button": "Upload",
        "dialog_tabs_names_camera_title": "File from web camera",
        "dialog_tabs_names_camera_capture": "Take a photo",
        "dialog_tabs_names_camera_mirror": "Mirror",
        "dialog_tabs_names_camera_startRecord": "Record a video",
        "dialog_tabs_names_camera_stopRecord": "Stop",
        "dialog_tabs_names_camera_retry": "Request permissions again",
        "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
        "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
        "notFound_title": "No camera detected",
        "notFound_text": "Looks like you have no camera connected to this device.",
        "dialog_tabs_names_preview_back": "Back",
        "dialog_tabs_names_preview_done": "Add",
        "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
        "dialog_tabs_names_preview_regular_title": "Add this file?",
        "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
        "dialog_tabs_names_preview_regular_line2": "Please confirm.",
        "dialog_tabs_names_preview_image_title": "Add this image?",
        "dialog_tabs_names_preview_crop_title": "Crop and add this image",
        "dialog_tabs_names_preview_crop_free": "free",
        "dialog_tabs_names_preview_video_title": "Add this video?",
        "dialog_tabs_names_preview_error_default_title": "Oops!",
        "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
        "dialog_tabs_names_preview_error_default_back": "Please try again",
        "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
        "dialog_tabs_names_preview_multiple_question": "Add files?",
        "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
        "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
        "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
        "dialog_tabs_names_preview_multiple_clear": "Remove all",
        "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
        "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
        "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
        "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
        "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
        "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
        "effects_captions_blur": "Blur",
        "effects_captions_crop": "Crop",
        "effects_captions_enhance": "Enhance",
        "effects_captions_flip": "Flip",
        "effects_captions_grayscale": "Grayscale",
        "effects_captions_invert": "Invert",
        "effects_captions_mirror": "Mirror",
        "effects_captions_rotate": "Rotate",
        "effects_captions_sharp": "Sharpen",
        "effects_apply_button": "Apply"
      },
      "fileRequiredButton": "",
      "previewStyle": "line_preview",
      "customStyling": {
        "container": "",
        "heading": "",
        "button": ""
      },
      "targetingType": "beginner",
      "thisProductVariants": false,
      "selectedProducts": [
        {
          "id": "gid://shopify/Product/7607998840916",
          "title": "Lil' Peacemaker Kids' Locket Necklace - Peace"
        },
        {
          "id": "gid://shopify/Product/7607998906452",
          "title": "Lil' Smiley Kids' Locket Necklace - Smiley Face"
        },
        {
          "id": "gid://shopify/Product/7607998873684",
          "title": "Lil' Sweetheart Kids' Locket Necklace - Heart"
        }
      ],
      "fopt4": false,
      "fileExtensions": [],
      "pdf_settings": {
        "enabled": false,
        "minimum": 0,
        "maximum": 3
      },
      "translations": []
    },
    {
      "fieldname": "Photo Upload - Pet Potrait",
      "directUpload": false,
      "atcTitle": "Upload your own photo",
      "uploadButtonText": "Upload Photo",
      "uploadButtonText2": "Change Photo",
      "dialogInstructionOne": "Choose an image from the list to crop or enhance it. To add more files, use the links on the left",
      "dialogInstructionTwo": "Choose an image from the list to crop or enhance it. To add more files, use the menu icon in the top left",
      "dialogInstructionThree": "If you have trouble uploading, click ⋮ in the top right, then 'Open in Chrome'",
      "buttonTextSize": "12",
      "buttonFontSize": 14,
      "fontStyle": "Theme Font",
      "introTitleColor": "#484848",
      "buttonCol": "#7E7E7E",
      "buttonBg": "#f1f1f1",
      "buttonTopBottomPadding": 10,
      "buttonLeftRightPadding": 10,
      "buttonBorderRadius": "0",
      "buttonWidth": "Full",
      "buttonDialogLang": "English",
      "dialogLanguage": "en",
      "opt1": true,
      "op2": false,
      "maximumFiles": 3,
      "minimumfiles": 0,
      "opt3": false,
      "fopt1": false,
      "fopt2": false,
      "fopt3": true,
      "pdf": false,
      "word": false,
      "customFile": false,
      "fileTypes": [],
      "buttonStatus": "Disable",
      "textFieldName": "Notes:",
      "fieldHelpText": "",
      "textFieldMaxLength": "No",
      "textFieldMaxChars": "30",
      "textFieldRequired": "No",
      "textFieldRequiredMessage": "Please enter a text!",
      "textFieldrequiredMessageButtonText": "OK",
      "fileSizeRestriction": false,
      "fileSizeRestrictionType": "minimumFileRestriction",
      "fileSizeMinimumRestriction": "2",
      "fileSizeMaximumRestriction": "4",
      "fileSizeMinMaxMinimum": "2",
      "fileSizeMinMaxMaximum": "4",
      "no": false,
      "yes": true,
      "fileRequiredMessage": "Please upload a file!",
      "fileRequiredMessageButtonText": "OK",
      "allowCropping": true,
      "croppingType": "aspect_ratio",
      "croppingAspectRatio": "4:4",
      "allowEditing": true,
      "editingType": "optional",
      "buttonStatus2": "Disable",
      "imageWidth": "1800",
      "imageHeight": "1200",
      "maxSizeRestriction": "Disable",
      "maxImageWidth": "1800",
      "maxImageHeight": "1200",
      "selectedUploadSources": "file url facebook gdrive gphotos dropbox flickr onedrive",
      "productCondition": {
        "condition": "",
        "products": [
          "Custom Pet Potrait Necklace - Classic Pave",
          "Custom Pet Portrait Necklace - Oval Starburst"
        ],
        "productIds": [
          "gid://shopify/Product/7772696805460",
          "gid://shopify/Product/7772696838228"
        ],
        "collection": [],
        "collectionIds": [],
        "prodOpt": "",
        "prodTitleEqual": [],
        "prodTitleContains": [],
        "collOpt": "",
        "collectionTitleEqual": [],
        "collectionTitleContains": []
      },
      "allVariants": true,
      "anyConditionVariant": false,
      "allConditionVariant": false,
      "noneConditionVariant": false,
      "allVariantValues": [],
      "anyConditionCheck": false,
      "allConditionCheck": false,
      "showAllFields": false,
      "thisProduct": true,
      "thisCollection": false,
      "ucCustomTransalations": {
        "uploading": "Uploading... Please wait.",
        "loadingInfo": "Loading info...",
        "errors_default": "Error",
        "error_invalid_filetype": "File type wrong. Only %extension% types are allowed.",
        "errors_baddata": "Incorrect value",
        "errors_size": "File too big",
        "errors_upload": "Can't upload",
        "errors_user": "Upload canceled",
        "errors_info": "Can't load info",
        "errors_image": "Only images allowed",
        "draghere": "Drop a file here",
        "one": "1 file",
        "file_other": "1 files",
        "buttons_cancel": "Cancel",
        "buttons_remove": "Remove",
        "buttons_choose_files_one": "Choose a file",
        "buttons_choose_files_other": "Choose files",
        "buttons_choose_images_one": "Choose an image",
        "buttons_choose_images_other": "Choose images",
        "dialog_close": "Close",
        "dialog_done": "Done",
        "dialog_showFiles": "Show files",
        "dialog_tabs_names_preview": "Preview",
        "dialog_tabs_names_file": "Local Files",
        "dialog_tabs_names_url": "Direct Link",
        "dialog_tabs_names_file_drag": "drag & drop<br>any files",
        "dialog_tabs_names_file_or": "or",
        "dialog_tabs_names_file_also": "or choose from",
        "dialog_tabs_names_file_button": "Choose a local file",
        "dialog_tabs_names_url_title": "Files from the Web",
        "dialog_tabs_names_url_line2": "Provide the link.",
        "dialog_tabs_names_url_input": "Paste your link here...",
        "dialog_tabs_names_url_button": "Upload",
        "dialog_tabs_names_camera_title": "File from web camera",
        "dialog_tabs_names_camera_capture": "Take a photo",
        "dialog_tabs_names_camera_mirror": "Mirror",
        "dialog_tabs_names_camera_startRecord": "Record a video",
        "dialog_tabs_names_camera_stopRecord": "Stop",
        "dialog_tabs_names_camera_retry": "Request permissions again",
        "dialog_tabs_names_camera_pleaseAllow_title": "Please allow access to your camera",
        "dialog_tabs_names_camera_pleaseAllow_text": "You have been prompted to allow camera access from this site.<br>In order to take pictures with your camera you must approve this request.",
        "notFound_title": "No camera detected",
        "notFound_text": "Looks like you have no camera connected to this device.",
        "dialog_tabs_names_preview_back": "Back",
        "dialog_tabs_names_preview_done": "Add",
        "dialog_tabs_names_preview_unknown_done": "Skip preview and accept",
        "dialog_tabs_names_preview_regular_title": "Add this file?",
        "dialog_tabs_names_preview_regular_line1": "You are about to add the file above.",
        "dialog_tabs_names_preview_regular_line2": "Please confirm.",
        "dialog_tabs_names_preview_image_title": "Add this image?",
        "dialog_tabs_names_preview_crop_title": "Crop and add this image",
        "dialog_tabs_names_preview_crop_free": "free",
        "dialog_tabs_names_preview_video_title": "Add this video?",
        "dialog_tabs_names_preview_error_default_title": "Oops!",
        "dialog_tabs_names_preview_error_default_text": "Something went wrong during the upload.",
        "dialog_tabs_names_preview_error_default_back": "Please try again",
        "dialog_tabs_names_preview_error_loadImage_text": "Can't load image",
        "dialog_tabs_names_preview_multiple_question": "Add files?",
        "dialog_tabs_names_preview_multiple_tooManyFiles": "You've chosen too many files. max is maximum.",
        "dialog_tabs_names_preview_multiple_title": "You've chosen files.",
        "dialog_tabs_names_preview_multiple_tooFewFiles": "You've chosen files. At least min required.",
        "dialog_tabs_names_preview_multiple_clear": "Remove all",
        "dialog_tabs_names_preview_size_restriction_minimum": "File dimensions are wrong. File dimensions of width %width% and height %height% or more are required.",
        "dialog_tabs_names_preview_size_restriction_maximum": "File dimensions are wrong. File dimensions of width %width% and height %height% or less are required.",
        "pdf_page_limitation_error": "%minpdf% PDF page(s) minimum and %maxpdf% PDF page(s) maximum are required.",
        "minimum_file_size_restriction_error": "File size wrong. File of at least %minsize% is required.",
        "maximum_file_size_restriction_error": "File size wrong. File of less than %maxsize% is required.",
        "minimum_and_maximum_file_size_restrictions_error": "File size wrong. File size minimum %minsize% and maximum %maxsize% required.",
        "effects_captions_blur": "Blur",
        "effects_captions_crop": "Crop",
        "effects_captions_enhance": "Enhance",
        "effects_captions_flip": "Flip",
        "effects_captions_grayscale": "Grayscale",
        "effects_captions_invert": "Invert",
        "effects_captions_mirror": "Mirror",
        "effects_captions_rotate": "Rotate",
        "effects_captions_sharp": "Sharpen",
        "effects_apply_button": "Apply"
      },
      "fileRequiredButton": "",
      "previewStyle": "line_preview",
      "customStyling": {
        "container": "",
        "heading": "",
        "button": ""
      },
      "targetingType": "beginner",
      "thisProductVariants": false,
      "selectedProducts": [
        {
          "id": "gid://shopify/Product/7772696805460",
          "title": "Custom Pet Potrait Necklace - Classic Pave"
        },
        {
          "id": "gid://shopify/Product/7772696838228",
          "title": "Custom Pet Portrait Necklace - Oval Starburst"
        }
      ],
      "fopt4": false,
      "fileExtensions": [],
      "pdf_settings": {
        "enabled": false,
        "minimum": 0,
        "maximum": 3
      },
      "translations": []
    }
  ],
  "buy_button": false,
  "direct_link": false,
  "store_branding": false,
  "dataType": "internal"
};
